import * as React from 'react';
import { useContext } from 'react';
import { Address } from '../../components/Address';
import { PromoOfferCard } from '../../components/PromoOfferCard';
import { Underground } from '../../components/Underground';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { trackCallButtonClick } from '../CallButton/tracking';
import { FavoritesButtonContainer } from '../FavoritesButtonContainer';
import { trackBlockClick } from '../PromoOffersSelection/tracking';

interface IOfferCardProps {
  onPromoModalOpen(e: React.MouseEvent): void;
}

export const OfferCard = ({ onPromoModalOpen }: IOfferCardProps) => {
  const {
    cardId,
    image,
    promoInfo,
    location,
    builder,
    newbuildingName,
    newbuildingUrl,
    price,
    description,
    offerId,
    offerUrl,
    gaLabel,
  } = useContext(PromoOfferCardContext);

  const trackCardClick = React.useCallback(() => {
    trackBlockClick({ offersIds: [offerId], clickType: 'to_offers' });
  }, [offerId]);

  const trackNewbuildingClick = React.useCallback(() => {
    trackBlockClick({ offersIds: [offerId], clickType: 'to_jk' });
  }, [offerId]);

  const trackCallClick = React.useCallback(() => {
    trackCallButtonClick({
      customUrl: gaLabel,
      id: offerId,
      action: 'Open_carousel_promo',
    });
  }, [gaLabel, offerId]);

  return (
    <PromoOfferCard
      cardId={cardId}
      backgroundImage={image}
      promoTitle={promoInfo.title}
      location={location.metro ? <Underground underground={location.metro} /> : <Address>{location.address}</Address>}
      logoUrl={builder.logo}
      newbuildingName={newbuildingName}
      newbuildingUrl={newbuildingUrl}
      trackCardClick={trackCardClick}
      favoriteButton={<FavoritesButtonContainer />}
      price={price}
      offerUrl={offerUrl}
      description={description}
      onPromoLabelClick={onPromoModalOpen}
      trackNewbuildingClick={trackNewbuildingClick}
      trackCallClick={trackCallClick}
    />
  );
};
